import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";

export default function VirtualAssistant() {
  return (
    <div className="Virtual-Assistant pt-[160px] sm:pt-0">
      <Helmet>
        <title>Best Virtual Assistant Services in Dubai | Mean3</title>
        <meta
        name="description"
        content="Simplify your tasks with our virtual assistant services in Dubai. Save time and increase productivity. Reach out to us today!"
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
    </div>
  );
}
